// extracted by mini-css-extract-plugin
export default {"map":"styles-module__map--EORt9"};